// Favre — przełącznik flag: zamykanie kliknięciem obok i klawiszem Escape.
(() => {
  const zamknij = (wyjatek) => {
    document.querySelectorAll('[data-favre-flaggen][open]').forEach((d) => {
      if (d !== wyjatek) d.removeAttribute('open');
    });
  };

  document.addEventListener('click', (e) => {
    zamknij(e.target.closest('[data-favre-flaggen]'));
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const otwarty = document.querySelector('[data-favre-flaggen][open]');
    if (!otwarty) return;
    otwarty.removeAttribute('open');
    otwarty.querySelector('summary')?.focus();
  });

  // Po wysłaniu formularza pokazujemy, że coś się dzieje (przeładowanie strony trwa chwilę).
  document.addEventListener('submit', (e) => {
    if (!e.target.classList.contains('favre-flaggen__form')) return;
    e.target.querySelector('button')?.setAttribute('aria-busy', 'true');
  });
})();
